export default {
  ticketCollectionMutation(state, data) {
    state.ticketCollection = data;
  },
  // 取票，登记游客信息
  setTouristInfo(state, data) {
    state.touristInfo = data;
  }
};
